// filter.component.ts

import { Component, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatRadioModule } from '@angular/material/radio'; 

@Component({
  selector: 'app-filter',
  standalone: true,
  templateUrl: './filter.component.html',
  styleUrls: ['./filter.component.scss'],
  imports: [
    CommonModule,
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatButtonModule,
    MatMenuModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatRadioModule
  ],
})
export class FilterComponent implements OnChanges {
  @Input() popupPosition: any = {};
  @Input() kind: string | undefined;
  @Input() currentFilterData: any = {};
  @Input() columnName = '';
  @Output() filter = new EventEmitter<{ column: string, condition: string, value: any }>();
  @Output() clear = new EventEmitter<void>();

  filterValue: string | number | boolean | Date = '';
  filterCondition: string = '';

  ngOnInit(){
    if (this.currentFilterData && this.currentFilterData.column === this.columnName) {
      this.filterValue = this.currentFilterData.value || '';
      this.filterCondition = this.currentFilterData.condition || 'equals';
    } else {
      this.filterValue = '';
      this.filterCondition = this.kind=='date'?'date_equals': this.kind=='number'?'number_equals':'equals';
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['currentFilterData'] && this.currentFilterData && this.currentFilterData.column === this.columnName) {
      this.filterValue = this.currentFilterData.value || '';
      this.filterCondition = this.currentFilterData.condition || 'equals';
    } else if (changes['currentFilterData']) {
      this.filterValue = '';
      this.filterCondition = this.kind=='date'?'date_equals': this.kind=='number'?'number_equals':'equals';
    }
  }

  applyFilter() {
    let valueToSend: string | number;

    if (this.filterValue instanceof Date) {
      valueToSend = this.filterValue.toISOString();
    } else if (typeof this.filterValue === 'number') {
      valueToSend = this.filterValue;
    }else if (typeof this.filterValue === 'boolean') {
      valueToSend = this.filterValue.toString();
    }     else {
      valueToSend = this.filterValue || '';
    }

    this.filter.emit({
      column: this.columnName,
      condition: this.filterCondition,
      value: valueToSend,
    });
  }

  clearFilter() {
    this.filterValue = '';
    this.filterCondition = 'equals';
    this.clear.emit();
  } 
}
